import { createApi } from '@reduxjs/toolkit/query/react'

import { ApiTag } from '../api-tags.enum'
import { HttpMethod } from '../http-method.enum'
import { SpecialistDto } from '@/lib/types'
import { apiBaseQuery } from '../base-query'

export const specialistsApi = createApi({
	reducerPath: 'specialistsApi',
	tagTypes: [ApiTag.Specialist],
	refetchOnReconnect: true,
	refetchOnFocus: true,
	baseQuery: apiBaseQuery,
	endpoints: (builder) => ({
		getAllSpecialists: builder.query<SpecialistDto[], { includeDeleted?: boolean } | void>({
			query: (params) => ({
				url: `/specialists/list`,
				method: HttpMethod.Get,
				params: params || {},
			}),
			providesTags: (result) => result
				? [ApiTag.Specialist, ...result.map(({ id }) => ({ type: ApiTag.Specialist as const, id }))]
				: [ApiTag.Specialist],
		}),
		getSpecialistById: builder.query<SpecialistDto, string>({
			query: (id) => `/specialists/list/${id}`,
			providesTags: (result, error, id) => result
				? [{ type: ApiTag.Specialist, id }]
				: [ApiTag.Specialist],
		}),
		deleteSpecialist: builder.mutation<null, string>({
			query: (id) => ({
				url: `/specialists/${id}`,
				method: HttpMethod.Delete,
			}),
			invalidatesTags: (result, error, id) => [
				ApiTag.Specialist,
				{ type: ApiTag.Specialist, id },
			],
		}),
		restoreSpecialist: builder.mutation<number, string>({
			query: (id) => ({
				url: `/specialists/${id}/restore`,
				method: HttpMethod.Patch,
			}),
			invalidatesTags: (result, error, id) => [
				ApiTag.Specialist,
				{ type: ApiTag.Specialist, id },
			],
		}),
	}),
})

export const { 
	useGetAllSpecialistsQuery,
	useGetSpecialistByIdQuery,
	useDeleteSpecialistMutation,
	useRestoreSpecialistMutation,
} = specialistsApi
